import { get } from 'lodash'
import { DATE_RANGE_THIS_YEAR, getDateRangeFromPreset } from 'components/filter/DateRangePresets'

const defaultRange = getDateRangeFromPreset(DATE_RANGE_THIS_YEAR)
export const getDateRangeFilter =
  (key, defaultDateRange = defaultRange) =>
  state =>
    get(state, key ? `filter.custom.${key}` : 'filter.dateRange', defaultDateRange)
